// <div data-countdown-wrapper>
//   <span data-days></span>
//   <span data-hours></span>
//   <span data-minutes></span>
//   <span data-seconds></span>
// </div>

function countdown() {
  const selectors = {
    wrapper: '[data-countdown-wrapper]',
    wrapperMirror: '[data-countdown-wrapper-mirror]',
    days: '[data-days]',
    hours: '[data-hours]',
    minutes: '[data-minutes]',
    seconds: '[data-seconds]',
    content: '[data-countdown-content]',
    contentPlaceholder: '[data-countdown-content-placeholder]',
  };

  const countdownWrapper = document.querySelector(selectors.wrapper);
  const wrapperMirror = document.querySelector(selectors.wrapperMirror);
  if (!countdownWrapper) return;

  const endDateString = countdownWrapper.dataset.countdownEnd;
  const endDate = new Date(endDateString).getTime();
  let days, hours, minutes, seconds;
  let intervalId;

  if (isNaN(endDate) || !countdownWrapper) {
    clearInterval(intervalId);
    showContent();
    return;
  }

  // setInterval(calculate, 1000);
  intervalId = setInterval(calculate, 300);

  function calculate() {

    let startDate = new Date().getTime();

    let timeRemaining = parseInt((endDate - startDate) / 1000);

    if (timeRemaining >= 0) {
      // days = parseInt(timeRemaining / 86400);
      days = parseInt(timeRemaining / 86400, 10);
      timeRemaining = (timeRemaining % 86400);

      hours = parseInt(timeRemaining / 3600);
      timeRemaining = (timeRemaining % 3600);

      minutes = parseInt(timeRemaining / 60);
      timeRemaining = (timeRemaining % 60);

      seconds = parseInt(timeRemaining);

      // countdownWrapper.querySelector(selectors.days).innerHTML = parseInt(days, 10);
      countdownWrapper.querySelector(selectors.days).innerHTML = days > 0 ? getTimeDisplay(days) + ':' : '';
      countdownWrapper.querySelector(selectors.hours).innerHTML = getTimeDisplay(hours) + ':';
      countdownWrapper.querySelector(selectors.minutes).innerHTML = getTimeDisplay(minutes) + ':';
      countdownWrapper.querySelector(selectors.seconds).innerHTML = getTimeDisplay(seconds);

      if (wrapperMirror) {
        wrapperMirror.innerHTML = countdownWrapper.innerHTML;
      }
    } else {
      clearInterval(intervalId);
      showContent();
      return;
    }
  }

  function getTimeDisplay(time) {
    return time < 10 ? '0' + time : time;
  }

  function showContent() {
    const countdownContent = document.querySelector(selectors.content);
    const countdownContentPlaceholder = document.querySelector(selectors.contentPlaceholder);

    if (countdownContent) {
      countdownContent.classList.remove('hide');

      const embedVideo = countdownContent.querySelector('.responsive-embed iframe');

      if (embedVideo && !embedVideo.src.includes('&autoplay=1')) {
        embedVideo.src += '&autoplay=1';
      }
    }

    if (countdownContentPlaceholder) {
      countdownContentPlaceholder.remove();
    }

    if (wrapperMirror) {
      wrapperMirror.remove();
    }
    // countdownWrapper.remove();
  }
}

(function () {
  countdown();
}());

document.addEventListener('DOMContentLoaded',function() {
  const donateButton = document.querySelectorAll('[data-donate-button], [data-close-donation-form]');

  if (!donateButton) return;

  donateButton.forEach((button) => {
    button.addEventListener('click', toggleDonationForm)
  });
});

const toggleDonationForm = function() {
  const donationForm = document.querySelector('#donation-form-wrapper');

  if (!donationForm) return;

  if (donationForm.classList.contains('hide')) {
    donationForm.classList.remove('hide');
    donationForm.scrollIntoView();
  } else {
    donationForm.classList.add('hide');
  }
}
